export default function () {
  return {
    availableLocales: [],
    locale: null,
  };
}
